import React from 'react';
import { Skeleton, Stack } from '@mui/material';

const LoadingState = () => {
  return (
    <Stack spacing={1}>
      <Skeleton variant="rectangular" width="100%" height={96} />
      <Skeleton variant="rectangular" width="100%" height={96} />
      <Skeleton variant="rectangular" width="100%" height={96} />
    </Stack>
  );
};

export default LoadingState;
